import React from "react";
import { FileImageOutlined, PlusOutlined } from "@ant-design/icons";
import ChantButton from "../../../CommonComponents/ChantButton/ChantButton";

const NoImages = ({ inputRef }) => {
  return (
    <div
      style={{
        height: "500px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        marginTop: "2px",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          width: "120px",
          height: "120px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        }}
      >
        <FileImageOutlined
          style={{
            fontSize: "48px",
            color: "#bbb",
          }}
        />
      </div>
      <div style={{ textAlign: "center", maxWidth: "400px" }}>
        <div
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "var(--primary-grey-text)",
            marginBottom: "8px",
          }}
        >
          No images yet
        </div>
        <div
          style={{
            fontSize: "15px",
            color: "#999",
            lineHeight: "1.6",
          }}
        >
          Start building your gallery by uploading photos. You can upload up to
          100 images at once.
        </div>
      </div>
      <ChantButton
        onClick={() => inputRef?.current.click()}
        style={{ marginTop: "8px" }}
      >
        <PlusOutlined style={{ marginRight: "8px" }} />
        Upload Photos
      </ChantButton>
    </div>
  );
};

export default NoImages;
